export default __webpack_public_path__ + "static/media/32.ebba0d5c.svg";